<template>
	<div class="top-div">
		<h5 class="title">{{$t('user.createwallet.create.name')}}</h5>
    <input class="input-text" maxlength="20" v-model="name" :placeholder="$t('user.createwallet.create.inputname')">
		<h5 class="title">
			{{$t('user.createwallet.create.pwd')}}
			<img
				v-if="this.pwdType === 'password'"
				@click="changeType()"
				class="eye"
				src="@/assets/image/eye.png"
			/>
			<img
				v-else
				@click="changeType()"
				class="eye"
				src="@/assets/image/eye_open.png"
			/>
		</h5>
		<input
			class="input-text password"
			v-model="password"
			:type="pwdType"
			auto-complete="off"
			:placeholder="$t('user.createwallet.create.inputpwd')"
		/>
		<input
			class="input-text"
			v-model="repassword"
			:type="pwdType"
			auto-complete="off"
			:placeholder="$t('user.createwallet.create.inputagain')"
		/>
		<p class="tips">{{$t('user.createwallet.create.tip-1')}}</p>
		<p class="tips">{{$t('user.createwallet.create.tip-2')}}</p>
		<button class="blue-btn" @click="createWallet()" v-loading="loading">{{$t('user.createwallet.create.crebtn')}}</button>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { validateWalletPass } from "@/utils/vaildate";
export default {
	computed: {
		...mapState("wallet", ["wallets"]),
	},
	methods: {
		...mapActions("wallet", ["createWallets"]),
		changeType() {
			this.pwdType = this.pwdType === "password" ? "text" : "password";
		},
		check() {
			if(!this.name){
        this.$tooltip.warning(this.$t('user.createwallet.create.inputname'));
        return false
      }
      if(!this.password){
        this.$tooltip.warning(this.$t('user.createwallet.create.tip-pwd'));
        return false
      }
			if (!validateWalletPass(this.password)) {
				this.$tooltip.warning(this.$t('user.createwallet.create.tip-correct'));
				return false;
			}
			if (this.password != this.repassword) {
				this.$tooltip.warning(this.$t('user.createwallet.create.tip-inconsistent'));
				return false;
			}
			return true;
		},
		async createWallet() {
      if(!this.check()) return
			try {
				this.loading = true
				await this.createWallets({
					passphrase: this.password,
					name:this.name
				});
				this.loading = false
				this.$emit("next", "IMToken");
			} catch(e) {
				this.loading = false
				this.$tooltip.warning('Error! Please try again.');
        console.log(e)
			}
		},
	},
	data() {
		return {
			pwdType: "password",
			password: "",
			repassword: "",
			name: "",
			loading: false,
		};
	},
};
</script>
<style lang="sass" scoped>
.top-div

  margin-top: 3rem
  .title
    font-size: 1.2rem
    font-weight: bold
    color: #333333
    position: relative
    .eye
      width: 1.3rem
      position: absolute
      right: 0
      top: 0.3rem
  .input-text
    width: 100%
    padding: 0.9rem 0
    font-size: 1.6rem
    font-weight: 400
    border: none
    border-bottom: 0.05rem solid #dedede
    color: rgba(51,51,51,1)
    margin-bottom: 4rem
    outline: none
  input::-webkit-input-placeholder
    color: rgba(51,51,51,0.1)
  input:-moz-placeholder
    color: rgba(51,51,51,0.1)
  input::-moz-placeholder
    color: rgba(51,51,51,0.1)
  input:-ms-input-placeholder
    color: rgba(51,51,51,0.1)
  .password
    margin-bottom: 1rem
  .tips
    font-size: 1.2rem
    font-weight: 400
    color: #D0021B
    line-height: 2.4rem
  .blue-btn
    outline: none
    width: 100%
    height: 4.9rem
    background: #DC472A
    border-radius: 0.4rem
    border: none
    color: #ffffff
    margin: 8rem 0 0 0
@media screen and (max-width: 768px)
  .blue-btn
    position: absolute
    bottom: 4.1rem
    transform: translateX(-50%)
    left: 50%
    max-width: 96%
</style>